// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.

export type AgentStudioClient = ReturnType<typeof createAgentStudioClient> & AgentStudioNodeHelpers;

import { gzipSync } from 'node:zlib';

import { createHmac } from 'node:crypto';

import { createMemoryCache, createNullCache, createNullLogger } from '@algolia/client-common';
import { createFetchRequester } from '@algolia/requester-fetch';

import type { ClientOptions } from '@algolia/client-common';

import { createAgentStudioClient } from '../src/agentStudioClient';

export { apiClientVersion } from '../src/agentStudioClient';

export * from '../model';

import type { AgentStudioNodeHelpers } from '../model';

export function agentStudioClient(
  appId: string,
  apiKey: string,
  options?: ClientOptions | undefined,
): AgentStudioClient {
  if (!appId || typeof appId !== 'string') {
    throw new Error('`appId` is missing.');
  }

  if (!apiKey || typeof apiKey !== 'string') {
    throw new Error('`apiKey` is missing.');
  }

  return {
    ...createAgentStudioClient({
      appId,
      apiKey,
      timeouts: {
        connect: 25000,
        read: 25000,
        write: 25000,
      },
      logger: createNullLogger(),
      requester: createFetchRequester(),
      algoliaAgents: [{ segment: 'Fetch' }],
      responsesCache: createNullCache(),
      requestsCache: createNullCache(),
      hostsCache: createMemoryCache(),
      compress: async (data: string): Promise<Uint8Array> => gzipSync(Buffer.from(data)),
      ...options,
    }),
    forgeSecuredUserToken({
      secretKey,
      secretKeyId,
      userId,
      expiresIn = 24 * 3600, // 24 hours
    }: {
      secretKey: string;
      secretKeyId: string;
      userId: string;
      expiresIn?: number;
    }): string {
      const header = Buffer.from(JSON.stringify({ alg: 'HS256', typ: 'JWT', kid: secretKeyId })).toString('base64url');
      const payload = Buffer.from(
        JSON.stringify({ sub: userId, exp: Math.floor(Date.now() / 1000) + expiresIn }),
      ).toString('base64url');
      const signature = createHmac('sha256', secretKey).update(`${header}.${payload}`).digest('base64url');
      return `${header}.${payload}.${signature}`;
    },
  };
}
